import React from 'react';
import EstrategiaModernaPage from './components/EstrategiaModernaPage';

function EstrategiaModerna() {
  return <EstrategiaModernaPage />;
}

export default EstrategiaModerna;
